import { render, staticRenderFns } from "./RecomOrderCardItem.vue?vue&type=template&id=408906c0"
import script from "./RecomOrderCardItem.vue?vue&type=script&lang=js"
export * from "./RecomOrderCardItem.vue?vue&type=script&lang=js"
import style0 from "./RecomOrderCardItem.vue?vue&type=style&index=0&id=408906c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports